export function getFormattingLanguage(controllerConfig) {
  return getMLLocale(controllerConfig) || controllerConfig.wixCodeApi.site.regionalSettings || 'en-US';
}
function getMLLocale(controllerConfig) {
  const currentLang = getCurrentlyUsedMultilingualLanguage(controllerConfig);
  if (!currentLang) {
    return undefined;
  }
  return currentLang.locale || controllerConfig.wixCodeApi.window.multilingual.currentLanguage;
}
function getCurrentlyUsedMultilingualLanguage(controllerConfig) {
  const currentShortLang = controllerConfig.wixCodeApi.window.multilingual.currentLanguage;
  return controllerConfig.wixCodeApi.window.multilingual.siteLanguages.find(lang => lang.languageCode === currentShortLang);
}
//# sourceMappingURL=getFormattingLanguage.js.map